import React, { useState, useEffect } from 'react';
import './style.css';
import { NavLink } from 'react-router-dom';
import { GoPackage } from "react-icons/go";
import { LuLayoutTemplate } from "react-icons/lu";
import { RiEdit2Line } from "react-icons/ri";
import { Payment } from '@mui/icons-material';
import { TbLogout } from 'react-icons/tb';
import { FaRegUserCircle } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logoutUser } from '../../../Redux/authAction';

const Index = () => {
  const [fullname, setFullname] = useState(''); // Store full name
  const [userId, setUserId] = useState(''); // Store user ID
  const isLang = useSelector((state) => state.authReducer.lang);
  const developername = useSelector((state) => state.authReducer.developername);
  const developeruid = useSelector((state) => state.authReducer.developeruid);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Retrieve and display user data from localStorage
  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem('userData')); // Use 'userData' as key based on your login code
    if (storedData && storedData.fullname && storedData.id) {
      setFullname(storedData.fullname); // Set the full name from stored data
      setUserId(storedData.id); // Set the user ID from stored data
    }
    // Example: Checking if language is stored
    const storedLang = localStorage.getItem('lang'); // Assuming language setting is stored in localStorage
    if (storedLang) {
      setIsLang(storedLang); // Set language from storage
    }
  }, []);

  const handleLogout = () => {
    // Clear local storage and reset state
    localStorage.removeItem('userData'); // Use the correct key 'userData' to clear the stored information
    dispatch(logoutUser());
    setFullname(''); // Clear the full name
    setUserId(''); // Clear the user ID
    navigate('/'); // Redirect to home page after logout
  };

  return (
    <>
      <div className='sideBarContainer'>
        <div className='imageDiv'>
          <img src='images/logo.png' style={{ width: '100%', height: '100%' }} alt="Logo" />
        </div>

        <div 
          className='link-container' 
          style={{ 
            textAlign: isLang === 'arabic' ? 'right' : 'left'  // Right align for Arabic, left align for English
          }}
        >
          <div>
            <NavLink to="/Templates"  className="nav-link">
              <LuLayoutTemplate style={{fontSize:'25px'}}  />
              {isLang === 'arabic' ? 'قوالب' : 'Templates'}
            </NavLink>

            <NavLink to="/Payments"  className="nav-link">
              <Payment style={{fontSize:'25px'}}  />
              {isLang === 'arabic' ? 'المدفوعات' : 'Payments'}
            </NavLink>

            <NavLink to="/ResumeMaker/temp/2"  className="nav-link" >
              <RiEdit2Line style={{fontSize:'25px'}} />
              {isLang === 'arabic' ? 'محرر فور يو' : '4U Editor'}
            </NavLink>
          </div>
          <div className='flex flex-col items-start -space-y-4'>
            <NavLink 
              to="/account" 
              className='flex justify-start items-center gap-2 nav-link w-full'
            >
              <FaRegUserCircle  style={{ fontSize: "24px"}} />
              {isLang === 'arabic' ? 'الملف الشخصي' : 'Profile'}
            </NavLink>
            <button 
              onClick={handleLogout} 
              className='flex justify-start w-full items-center gap-2 nav-link' 
            >
              <TbLogout  style={{ fontSize: "24px" }}  />
              {isLang === 'arabic' ? 'تسجيل خروج' : 'Logout'}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Index;
